import { createFileRoute } from "@tanstack/react-router";
import { Tags } from "@/features/settings/tags";

export const Route = createFileRoute("/settings/tags")({
  component: Tags,
});
